import { FlowV2_Action__Input } from '~/graphql/types';
import { ClientFlowActionContactAssign } from '~/graphql/types.client';
import removeTypenames from '~/util/removeTypenames';

/**
 *
 * @param {ClientFlowActionContactAssign} action - ContactAssign client action
 * keywords:
 */
const serializeContactAssignAction = (
  action: ClientFlowActionContactAssign,
): FlowV2_Action__Input => {
  const {
    id,
    accountId,
    flowBlueprintId,
    parentIds,
    overwriteAssignee,
    office,
    user,
    setByWorkingArea,
    address,
  } = action;

  const optionalFields = (() => {
    if (setByWorkingArea) {
      return {
        setByWorkingArea,
        address,
      };
    }

    return {
      setByWorkingArea,
      address: undefined,
    };
  })();

  return {
    Contact: {
      Assign: removeTypenames({
        id,
        accountId,
        flowBlueprintId,
        parentIds,
        office,
        user,
        overwriteAssignee,
        ...optionalFields,
      }),
    },
  };
};
export default serializeContactAssignAction;
